// simpleController.js
var SimpleController = pc.createScript('simpleController');

// initialize code called once per entity
SimpleController.prototype.initialize = function() {
    
    this.vecA = new pc.Vec3();
    this.vecB = new pc.Vec3();
    this.matA = new pc.Mat4();
    this.quat = new pc.Quat();
    this.color = new pc.Color(1, 1, 1);
    
    this.modelEntity = this.entity.findByName('model');
    this.hoverEntity = null;
    
    this.targetPointerSize = 2;
    this.targetTeleportable = false;
    //this.pointer = this.entity.findByName('pointer');
    //this.pointer.element.material.depthTest = false;
    //this.hoverPoint = new pc.Vec3();
    this.pointerDistance = 3;
    this.moving = true;
    this.rotating = true;
    this.dir = 0;
    this.menu = false;
    axLYonce = true;
    axRYonce = true;
    axLXonce = true;
    axRXonce = true;
    axMoveOnceL = true;
    axMoveOnceR = true;
    axRotOnceL = true;
    axRotOnceR = true;
    stateLeft = null;
    stateRight = null;
    this.app.on('controllerHandler:updateStates', this.updateStates, this); // if a controller is registered
};

SimpleController.prototype.setInputSource = function(inputSource) {
    var self = this;
    
    this.inputSource = inputSource;
    this.inputSource.once('remove', this.onRemove, this);
    
    this.on('hover', this.onHover, this);
    this.on('blur', this.onBlur, this);
    
    this.inputSource.on('select', this.onSelect, this);
};

SimpleController.prototype.onSelect = function() {
    this.app.fire('object:pick', this);
    if (this.hoverEntity) {
        // teleport
        if (this.targetTeleportable) {
            if(stateLeft == 'teleport'){
                this.app.fire('controller:teleport', this.hoverPoint);
            } else if(stateRight == 'teleport'){
                this.app.fire('controller:teleport', this.hoverPoint);
            }
        // paint interactible model
        } else if (this.hoverEntity.tags.has('interactive')) {
            var mesh = this.hoverEntity.model.meshInstances[0];
            if (! mesh.pickedColor) mesh.pickedColor = new pc.Color();

            mesh.pickedColor.set(Math.random(), Math.random(), Math.random());
            mesh.setParameter('material_diffuse', mesh.pickedColor.data3);
        }
    }
};

SimpleController.prototype.onHover = function(entity, point) {
   
};

SimpleController.prototype.onBlur = function() {
    this.hoverEntity = null;
    this.targetPointerSize = 4;
    this.targetTeleportable = false;
};

SimpleController.prototype.updateStates = function(hnd, st){
    if(hnd == 'left'){
        stateLeft = st;
    } else if(hnd == 'right'){
        stateRight = st;
    }
};

// update code called every frame
SimpleController.prototype.update = function(dt) {
    // pick entities
   // this.app.fire('object:pick', this);
  

    // gamepad input
    var gamepad = this.inputSource.gamepad;
                    
    if (gamepad) {

        
        //ROTATION WITH THUMBSTICK
        
        if (this.inputSource.handedness === pc.XRHAND_LEFT && (gamepad.axes[3] || gamepad.axes[2])) {
            if(this.rotating){
                if(stateLeft == 'rotate'){
                    this.app.fire('controller:rotate', -gamepad.axes[2], dt);  
                    this.app.fire('controller:stickRotate', 'left', gamepad.axes[2], gamepad.axes[3]);
                    axRotOnceL = true;
                }
            } 
        }
        if (this.inputSource.handedness === pc.XRHAND_RIGHT && (gamepad.axes[3] || gamepad.axes[2])) {
            if(this.rotating){
                if(stateRight == 'rotate'){
                    this.app.fire('controller:rotate', -gamepad.axes[2], dt);
                    this.app.fire('controller:stickRotate', 'right', gamepad.axes[2], gamepad.axes[3]);
                    axRotOnceR = true;
                }
            } 
        } 
        if (this.inputSource.handedness === pc.XRHAND_LEFT && (!gamepad.axes[3] || !gamepad.axes[2])) {
            if(axRotOnceL){
                axRotOnceL = false;
                this.app.fire('controller:stickRotate', 'left', 0, 0);
            }
        }
        if (this.inputSource.handedness === pc.XRHAND_RIGHT && (!gamepad.axes[3] || !gamepad.axes[2])) {
            if(axRotOnceR){
                axRotOnceR = false;
                this.app.fire('controller:stickRotate', 'right', 0, 0);
            }
        }
      
 
    }
};

